import { io, Socket } from 'socket.io-client';
import { fetchAuthSession } from '@aws-amplify/core';

let socket: Socket | null = null;

const DEBUG_SOCKET = true;

export async function connectSocket() {
  if (socket) return socket;

  const url = process.env.REACT_APP_NODE_BACKEND!;
  const { tokens } = await fetchAuthSession();

  if (!tokens?.idToken) {
    throw new Error('User Not found');
  }

  const token = tokens.idToken.toString();

  socket = io(url, {
    transports: ['websocket'],
    withCredentials: true,
    auth: { token },
  });

  socket.on('connect', () => console.log('🟢 socket connected:', socket?.id));
  socket.on('disconnect', (reason) =>
    console.log('🔌 socket disconnected:', reason)
  );
  socket.on('connect_error', (err) =>
    console.log('❌ socket connect_error:', err.message)
  );

  if (DEBUG_SOCKET) {
    console.log('Initializing Socket Events for Debugging!!!!');

    socket.onAny((event, ...args) => {
      console.log('📡 [SOCKET EVENT RECEIVED]');
      console.log('event:', event);
      console.log('args:', args);
    });
  }

  return socket;
}

export function getSocket() {
  if (!socket)
    throw new Error('Socket not connected. Call connectSocket() first.');
  return socket;
}

export function disconnectSocket() {
  socket?.disconnect();
  socket = null;
}
